import axios from "axios";
import {
  getBlockchainNodeUrl,
  SERVER_BASE_ADDRESS,
  DECIMAL_ROUND,
} from "./const";
import React from "react";
import CryptoJS from "crypto-js";
import { isAuthenticated } from "./authentication";
import { ACRES_TO_HECTARES_RATIO } from "../globals/const";

export const getFromBackend = (url, useAuth = true) => {
  const token = window.localStorage.getItem("token");

  var headers;
  if (useAuth) {
    headers = {
      "Content-Type": "application/json",
      Authorization: "Token " + token,
    };
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }

  return axios
    .get(SERVER_BASE_ADDRESS + url, { headers: headers })
    .then((result) => result.data);
};

export const postToBackend = (url, data) => {
  const token = window.localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Token " + token,
  };

  return axios
    .post(SERVER_BASE_ADDRESS + url, data, { headers: headers })
    .then((result) => result.data);
};

export function logout() {
  window.sessionStorage.clear();
  localStorage.clear();
  window.location = "/";
}

export function ValidateEmail(mail) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return true;
  }
  alert("You have entered an invalid email address!");
  return false;
}

export function isLoggedIn() {
  return isAuthenticated();
}

export function getColorForRiskWording(riskValue) {
  switch (riskValue) {
    case "Very Low":
      return "#29812c";
    case "Low":
      return "#8bc34a";
    case "Medium":
      return "#ffc107";
    case "High":
      return "#e36944";
    case "Very High":
      return "#ee2e31";
    default:
      return "black";
  }
}

export function getColorForRecommendation(recommendation) {
  var backgroundColor = "white";
  var fontColor = "black";

  switch (recommendation) {
    case "STRONG_BUY":
      backgroundColor = "#29812c";
      fontColor = "white";
      break;
    case "BUY":
      backgroundColor = "#8bc34a";
      fontColor = "white";
      break;
    case "HOLD":
    case "WEAK_HOLD":
    case "STRONG_HOLD":
      backgroundColor = "#ffbf00";
      fontColor = "white";
      break;
    case "SELL":
    case "WEAK_SELL":
      backgroundColor = "#e36944";
      fontColor = "white";
      break;
    case "STRONG_SELL":
      backgroundColor = "#ee2e31";
      fontColor = "white";
      break;
    default:
      break;
  }

  return { backgroundColor: backgroundColor, fontColor: fontColor };
}

export function getRiskReturnComparisonBigText(verdict) {
  switch (verdict) {
    case "Risk << Returns":
      return (
        <div>
          <span style={{ fontSize: "12px" }}>Risk</span> &lt;{" "}
          <span style={{ fontSize: "16px" }}>Returns</span>
        </div>
      );
    case "Risk < Returns":
      return (
        <div>
          <span style={{ fontSize: "12px" }}>Risk</span> &lt;{" "}
          <span style={{ fontSize: "14px" }}>Returns</span>
        </div>
      );
    case "Risk ~ Returns":
      return (
        <div>
          <span style={{ fontSize: "12px" }}>Risk</span> ~{" "}
          <span style={{ fontSize: "12px" }}>Returns</span>
        </div>
      );
    case "Risk > Returns":
      return (
        <div>
          <span style={{ fontSize: "14px" }}>Risk</span> &gt;{" "}
          <span style={{ fontSize: "12px" }}>Returns</span>
        </div>
      );
    case "Risk >> Returns":
      return (
        <div>
          <span style={{ fontSize: "16px" }}>Risk</span> &gt;{" "}
          <span style={{ fontSize: "12px" }}>Returns</span>
        </div>
      );
    default:
      return "";
  }
}

export const scaleImageMap = {
  "Risk << Returns": "/hawkeye/images/report/tradeoff-inverted.jpg",
  "Risk < Returns": "/hawkeye/images/report/tradeoff-inverted.jpg",
  "Risk ~ Returns": "/hawkeye/images/report/equalriskreturn.png",
  "Risk > Returns": "/hawkeye/images/report/tradeoff.jpg",
  "Risk >> Returns": "/hawkeye/images/report/tradeoff.jpg",
};

export const isValidWalletAddress = (address) => {
  return /^0x([a-f0-9]){40,40}$/.test(address);
};

export const signTransaction = async (transaction, wallet) => {
  let res = await axios.post(getBlockchainNodeUrl() + "/sign-transaction", {
    wallet_data: wallet,
    transaction_data: transaction,
  });
  return res.data;
};

export const isWalletDownloaded = async (walletAddress) => {
  const walletDownloaded = localStorage.getItem("DOWNLOADED:" + walletAddress);
  console.log(walletDownloaded === "yes");
  return walletDownloaded === "yes";
};

export const setWalletDownloaded = async (walletAddress) => {
  localStorage.setItem("DOWNLOADED:" + walletAddress, "yes");
};

export const getDecimal = (token_code) => {
  if (["NWRL", "NUSDC", "NUSDCTEST"].includes(token_code)) {
    return 1000000;
  } else {
    return 1;
  }
};

export function roundDec(value, dec_digits = DECIMAL_ROUND) {
  return (
    Math.round(value * Math.pow(10, dec_digits)) / Math.pow(10, dec_digits)
  );
}

export function convertWeight(value, dec_digits = 3) {
  return parseInt(value * 10 ** dec_digits);
}

function arrayBufferToWordArray(ab) {
  var i8a = new Uint8Array(ab);
  var a = [];
  for (var i = 0; i < i8a.length; i += 4) {
    a.push(
      (i8a[i] << 24) | (i8a[i + 1] << 16) | (i8a[i + 2] << 8) | i8a[i + 3]
    );
  }
  return CryptoJS.lib.WordArray.create(a, i8a.length);
}

export function handleFileSelect(evt, setValueCallback) {
  var files = evt.target.files; // FileList object

  // Loop through the FileList and render image files as thumbnails.
  for (var i = 0, f; (f = files[i]); i++) {
    var reader = new FileReader();

    // Closure to capture the file information.
    reader.onloadend = (function () {
      return function (e) {
        var arrayBuffer = e.target.result;

        var hash = CryptoJS.SHA256(arrayBufferToWordArray(arrayBuffer));
        setValueCallback(hash);
        //   var elem = document.getElementById("hashValue");
        //   elem.value = hash;
      };
    })(f);
    reader.onerror = function (e) {
      console.error(e);
    };

    // Read in the image file as a data URL.
    reader.readAsArrayBuffer(f);
  }
}

export function getAreaInAcres(polygon) {
  // Earth’s radius in meters
  const R = 6378137;

  // Convert degrees to radians
  function toRadians(degree) {
    return degree * (Math.PI / 180);
  }

  // Calculate the area using the Shoelace formula
  function shoelaceFormula(coordinates) {
    let area = 0;
    for (let i = 0; i < coordinates.length - 1; i++) {
      const x1 = coordinates[i].lng;
      const y1 = coordinates[i].lat;
      const x2 = coordinates[i + 1].lng;
      const y2 = coordinates[i + 1].lat;

      area +=
        toRadians(x1) * Math.sin(toRadians(y2)) -
        toRadians(x2) * Math.sin(toRadians(y1));
    }
    return Math.abs((area * R * R) / 2.0);
  }

  // Calculate the polygon's area in square meters
  const areaInSquareMeters = shoelaceFormula([...polygon, polygon[0]]); // Ensure the polygon is closed by adding the first point at the end

  // Convert square meters to acres (1 acre = 4,046.8564224 square meters)
  const areaInAcres = areaInSquareMeters / 4046.8564224;

  return areaInAcres;
}

//TODO: Enable this once fixed or use backend for validation
// export function isPointInPolygon(point, polygon) {
//   console.log("isPointInPolygon", point, polygon);
//   let isInside = false;
//   for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
//     const xi = polygon[i].lat,
//       yi = polygon[i].lng;
//     const xj = polygon[j].lat,
//       yj = polygon[j].lng;

//     const intersect =
//       yi > point.latitude !== yj > point.latitude &&
//       point.longitude < ((xj - xi) * (point.latitude - yi)) / (yj - yi) + xi;
//     if (intersect) isInside = !isInside;
//   }
//   return isInside;
// }

export async function compressImage(file) {
  const MAX_WIDTH = 800;
  const reader = new FileReader();
  const fileName = file.name;
  const lastModified = file.lastModified;
  const type = file.type;

  const eventToPromise = (target, event) =>
    new Promise((resolve) =>
      target.addEventListener(event, resolve, { once: true })
    );

  const dataUrl = await new Promise((resolve) => {
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });

  const image = new Image();
  image.src = dataUrl;

  await eventToPromise(image, "load");

  const canvas = document.createElement("canvas");
  let width = image.width;
  let height = image.height;

  if (width > MAX_WIDTH) {
    height *= MAX_WIDTH / width;
    width = MAX_WIDTH;
  }

  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(image, 0, 0, width, height);

  const blob = await new Promise((resolve) =>
    canvas.toBlob(resolve, "image/jpeg", 0.7)
  );

  const compressedFile = new File([blob], fileName, { type, lastModified });

  return compressedFile;
}

/**
/**
 * Checks if the provided data is a non-null, non-empty array.
 * @param {Array} data - The data to check.
 * @returns {Boolean} - Returns true if data is a non-null, non-empty array, otherwise false.
 */
export const isNotNullOrEmptyArray = (data) => {
  return data && Array.isArray(data) && data.length > 0;
};

export const getFarmerPlotId = () => {
  let farmerPlotId = "";
  if (localStorage.getItem("farmerPlotId")) {
    farmerPlotId = localStorage.getItem("farmerPlotId");
  }
  return farmerPlotId;
};

/**
 * Filters out empty values from an object.
 *
 * This function iterates over the properties of the given object and removes
 * properties that have empty string values, null values, or File objects with
 * a size of 0.
 *
 * @param {Object} obj - The object to filter.
 * @returns {Object} - A new object with empty values removed.
 */

export const filterEmptyValues = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, value]) => value && !(value instanceof File && value.size === 0)
    )
  );

/**
 * Returns the emoji corresponding to the given color.
 * @param {String} color - The color to get the emoji for.
 * @returns {String} - The emoji corresponding to the given color.
 */
export const getEmojiFromColor = (color) => {
  if (color === "red") return "😞";
  if (color === "orange") return "😐";
  if (color === "green") return "😊";
  return "";
};

export const transformBackendErrors = (backendErrors) => {
  const flattenedErrors = {};

  const flattenErrors = (errors, path = "") => {
    Object.keys(errors).forEach((key) => {
      const newPath = path ? `${path}.${key}` : key;
      if (typeof errors[key] === "object" && !Array.isArray(errors[key])) {
        flattenErrors(errors[key], newPath);
      } else {
        // Ensure we handle both arrays and single messages
        flattenedErrors[newPath] = Array.isArray(errors[key])
          ? errors[key][0]
          : errors[key];
      }
    });
  };

  flattenErrors(backendErrors);
  return flattenedErrors;
};

/**
 * Converts a Kelvin temperature value to Celsius.
 * @param {Number} kelvin - The temperature in Kelvin.
 * @returns {String} - The temperature in Celsius, rounded to 2 decimal places.
 */
export function kelvinToCelsius(kelvin) {
  const celius = kelvin - 273.15;
  return celius.toFixed(1);
}

const roleMapping = {
  FARMER: "Farmer",
  FPO: "FPO",
  LENDER: "Lender",
  AUDITOR: "Auditor",
  FPO_DIRECTOR: "FPO Director",
  FPO_CEO: "FPO CEO",
  FPO_AGGREGATOR: "FPO Aggregator",
  BUYER: "Buyer",
  SERVICE_PROVIDER: "Service Provider",
  PROGRAM_MANAGER: "Program Manager",
  SPONSOR: "Sponsor",
  POP_MANAGER: "POP Manager",
  AREA_MANAGER: "Area Manager",
  VLE: "VLE",
  ADMIN: "Admin",
  CA: "Central Admin",
  EXTERNAL_MANAGER: "External Manager",
  FRANCHISE: "Franchise",
};

export function getMappedRole(role) {
  return roleMapping[role] || "";
}

const stateToLanguageMap = {
  Gujarat: "gu",
  Maharashtra: "mr",
  Punjab: "pa",
  Odisha: "or",
  Karnataka: "kn",
  TamilNadu: "ta",
  JammuAndKashmir: "hi",
  HimachalPradesh: "hi",
  Haryana: "hi",
  Delhi: "hi",
  UttarPradesh: "hi",
  Uttarakhand: "hi",
  Rajasthan: "hi",
  Bihar: "hi",
  Jharkhand: "hi",
  MadhyaPradesh: "hi",
  Chhattisgarh: "hi",
};

export default function useLanguageFromLocation(state) {
  return stateToLanguageMap[state] || "en"; // default to English if no match
}

export function handleMobileKeyDown(event) {
  // Prevent input if the key is not a digit or allowed key
  if (
    !/[0-9]/.test(event.key) &&
    !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(event.key)
  ) {
    event.preventDefault();
  }
}

export function getStatusColor(status, isPaid) {
  if (status === "DELIVERED" || status === "PAID" || isPaid) {
    return "success";
  }
  return "error";
}

export const getButtonBackgroundColor = (color) => {
  switch (color) {
    case "primary":
      return "primary";
    case "info":
      return "#2196f3";
    default:
      return "#F7A419";
  }
};

export const UNIT_TYPE = {
  HECTARES: "hectares",
};

export const acresToHectares = (acres) => {
  const area = (acres || 0) * ACRES_TO_HECTARES_RATIO;
  if (isNaN(area)) return "0.00";
  return area.toFixed(2);
};

/* Format Unix timestamp to readable date in hh:mm AM/PM DD MM YYYY format
 * @param {number} timestamp - The Unix timestamp to format.
 * @returns {string} - The formatted date string.
 * Example: 1633072800 -> "10:00 AM 01/10/2021"
 */
export const formatUnixTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const hours = date.getHours() % 12 || 12;
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = date.getHours() >= 12 ? "PM" : "AM";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${hours}:${minutes} ${ampm} ${day}/${month}/${year}`;
};

export const currentDate = (date = new Date()) => {
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

export function getPolygonCenter(coords) {
  // Make sure we have at least 3 points
  if (!coords || !coords.length || coords.length < 3) {
    console.error(
      "Invalid coordinates provided for polygon center calculation."
    );
    return null;
  }

  // Copy and close the polygon (first === last)
  const pts = coords.slice();
  if (
    pts[0].lat !== pts[pts.length - 1].lat ||
    pts[0].lng !== pts[pts.length - 1].lng
  ) {
    pts.push({ ...pts[0] });
  }

  let area = 0;
  let x = 0;
  let y = 0;

  for (let i = 0; i < pts.length - 1; i++) {
    const xi = pts[i].lng;
    const yi = pts[i].lat;
    const xi1 = pts[i + 1].lng;
    const yi1 = pts[i + 1].lat;
    const cross = xi * yi1 - xi1 * yi;
    area += cross;
    x += (xi + xi1) * cross;
    y += (yi + yi1) * cross;
  }

  area *= 0.5;
  if (area === 0) {
    // Fallback to arithmetic mean if area is zero (degenerate)
    const sum = coords.reduce(
      (acc, { lat, lng }) => {
        acc.lat += lat;
        acc.lng += lng;
        return acc;
      },
      { lat: 0, lng: 0 }
    );
    return { lat: sum.lat / coords.length, lng: sum.lng / coords.length };
  }

  const factor = 1 / (6 * area);
  const centerLng = x * factor;
  const centerLat = y * factor;

  return { lat: centerLat, lng: centerLng };
}

export const languages = [
  { value: "en", label: "English" },
  { value: "hi", label: "हिन्दी" },
  { value: "gu", label: "ગુજરાતી" },
  { value: "pa", label: "ਪੰਜਾਬੀ" },
  { value: "mr", label: "मराठी" },
  { value: "ta", label: "தமிழ்" },
  { value: "kn", label: "ಕನ್ನಡ" },
  { value: "or", label: "ଓଡ଼ିଆ" },
];
